<template>
  <div class="quiz-container">
    <div class="anime" v-if="loadedInfo">
      <div class="loader"></div>
    </div>

    <div v-if="!loadedInfo">
      <final-result :finished="finished" :total="total" :score="score" />
      <div class="quiz-inner">
        <div v-if="oneQuestionMode && !finished" class="question-container">
          <question
            :key="currentQuestion.id"
            :number="currentQuestionIndex + 1"
            :question="currentQuestion"
            @onTimelineSelect="onTimelineSelect"
            :userAnswer="user_answers[currentQuestion.id]"
            @onSelect="(option) => onSelectAndAnswer(option, currentQuestionIndex)"
            :showDivder="!oneQuestionMode || finished"
          />
          <quiz-actions @next="next" :finished="finished" />
        </div>
        <div v-else class="question-container">
          <question
            v-for="(question, i) in questions"
            :oneQuestionMode="oneQuestionMode"
            :key="question.id"
            :number="(i + 1)"
            :question="question"
            :userAnswer="user_answers[question.id]"
            @onSelect="(option) => onSelectAndAnswer(option, i)"
            @onTimelineSelect="onTimelineSelect"
            :showDivder="!oneQuestionMode || finished"
          />
        </div>
        <div class="quiz-inner__left">
          <div class="score-container">
            <div class="actions">
              <div class="timer-component"><quiz-timer :storage_key="getStorageKey()" /></div>
              <problem-modal
                :questions="questions"
                :question_id="currentQuestion.id"
                :test="test"
              />
              <button type="button" class="icon-btn__with-text" @click="startAgain">
                <div class="hover-text">
                  თავიდან დაწყება
                </div>
                <i class="fas fa-sync spin danger-color-hover"></i>
              </button>

              <button @click="toggleQuiz" type="button" class="icon-btn__with-text">
                <div class="hover-text">
                  {{ this.oneQuestionMode ? 'ყველა კითხვა რეჟიმი' : 'ერთი კითხვის რეჟიმი' }}
                </div>
                <i
                  class="fas fa-clipboard-list success-color-hover"
                  :class="{ 'text-success': !this.oneQuestionMode }"
                ></i>
              </button>
            </div>
          </div>
          <quiz-stats
            :isFinished="finished"
            :storage_key="getStorageKey()"
            :correctAnswers="score"
            :wrongAnswers="wrongAnswers"
            :totalQuestions="questions.length"
          />
        </div>
      </div>

      <questions-paging
        :questions="questions"
        :user_answers="user_answers"
        :currentQuestionIndex="currentQuestionIndex"
        @setCurrentQuestoinIndex="updateCurrentQuestoinIndexAndScrollToIt"
      />
    </div>
  </div>
</template>
<style lang="scss">
.c-black {
  color: black;
}
</style>

<script>
import { scrollToElement } from '../../helpers/scroll-to-element';
import { getQuestionElId, scrollIfQuestionIsOutOfView } from './helpers';
export default {
  props: ['user_id', 'questions', 'test'],
  data() {
    return {
      loadedInfo: false,
      score: 0,
      wrongAnswers: 0,
      currentQuestionIndex: 0,
      answer: null,
      user_answers: {},
      oneQuestionMode: false,
      total: this.questions.length,
      timeline: {},

      finished: false,
    };
  },
  methods: {
    getStorageKey() {
      return this.test.slug || this.test.id;
    },
    onTimelineSelect(timeline, question) {
      this.timeline = { ...this.timeline, ...timeline };
      if (this.hasMarkedAllTimeline(question)) {
        this.check(question);
      }
    },
    onSelect(option) {
      this.answer = option;
    },
    onSelectAndAnswer(option, index) {
      this.onSelect(option);
      this.currentQuestionIndex = index;
      this.check(this.currentQuestion);
    },
    //
    hasAnswered(question) {
      return !!this.user_answers[question.id];
    },
    hasMarkedAllTimeline(question = false) {
      question = question || this.currentQuestion;
      for (let option of question.options) {
        if (!this.timeline[option.id]) {
          return false;
        }
      }
      return true;
    },
    checkIfFinished() {
      let answersCount = Object.keys(this.user_answers).length;
      if (this.total <= answersCount) {
        this.finished = true;
        this.oneQuestionMode = false;
        setTimeout(() => {
          if (this.oneQuestionMode) {
            const el = document.getElementById('final-result');
            if (el) scrollToElement(el, { space: -25 });
          }
        }, 50);
      }
    },
    check(question) {
      if (question.type_id != 2) {
        if (!this.answer) return;
        if (this.answer.correct) {
          this.score++;
        } else {
          this.wrongAnswers++;
        }
        this.user_answers = {
          [this.answer.question_id]: this.answer,
          ...this.user_answers,
        };
        this.answer = null;
      } else {
        let correctTimeline = 0;
        for (let option of question.options) {
          if (!this.hasMarkedAllTimeline(question)) {
            return alert('select all options');
          }
          if (
            question.options.find((o) => o.id === option.id).timeline == this.timeline[option.id]
          ) {
            correctTimeline++;
          }
        }
        if (question.options.length === correctTimeline) {
          this.score++;
        } else {
          this.wrongAnswers++;
        }
        this.user_answers = {
          [question.id]: this.timeline,
          ...this.user_answers,
        };
        this.timeline = {};
      }
      this.storeInStorage(this.getNextCurrentQuestoin());
      if (!this.oneQuestionMode) this.checkIfFinished();
    },
    getNextCurrentQuestoin() {
      let newCurrentQuestoinIndex = 1;
      let i = this.currentQuestionIndex + 1;
      let found = false;
      while (i !== this.currentQuestionIndex && this.questions[i]) {
        let q = this.questions[i];
        if (!this.user_answers[q.id]) {
          newCurrentQuestoinIndex = i;
          found = true;
          break;
        }
        if (this.questions[i + 1]) {
          i++;
        } else {
          i = 0;
        }
      }

      if (!found) {
        this.questions.every((q, i) => {
          if (!this.user_answers[q.id]) {
            newCurrentQuestoinIndex = i;
            return false;
          }
          return true;
        });
      }
      return newCurrentQuestoinIndex;
    },
    next() {
      let answersCount = Object.keys(this.user_answers).length;
      if (this.total > answersCount) {
        this.currentQuestionIndex = this.getNextCurrentQuestoin();
      }
      this.checkIfFinished();
      this.storeInStorage();
      this.scrollToCurrentQuestion();
    },
    toggleQuiz() {
      this.oneQuestionMode = !this.oneQuestionMode;
      this.scrollToCurrentQuestion();
    },

    scrollToCurrentQuestion(timeout = 350) {
      setTimeout(() => {
        let space = this.finished ? -92 : -100;
        scrollIfQuestionIsOutOfView(this.currentQuestion.id, space);
      }, timeout);
    },

    updateCurrentQuestoinIndexAndScrollToIt(index) {
      this.currentQuestionIndex = index;
      let timeout = this.finished ? 0 : null;
      this.scrollToCurrentQuestion();
      this.storeInStorage();
    },
    startAgain() {
      if (confirm('ნამდვილად გსურთ ტესტის თავიდან დაწყება?')) {
        this.currentQuestionIndex = 0;
        this.user_answers = {};
        this.answer = '';
        this.timeline = {};
        this.score = 0;
        this.wrongAnswers = 0;
        // this.oneQuestionMode = true;
        this.finished = false;

        localStorage.removeItem(this.getStorageKey());
        window.bus.$emit('resetQuizTimer');
      }
    },
    // store user answers in storage
    storeInStorage(currentQuestionIndex) {
      let data = {
        testId: this.test.id,
        answers: this.user_answers,
        currentQuestionIndex: currentQuestionIndex || this.currentQuestionIndex,
        score: this.score,
        finished: this.finished,
      };
      localStorage.setItem(this.getStorageKey(), JSON.stringify(data));
    },
    getAnswersFromStorage() {
      let data = localStorage.getItem(this.getStorageKey());
      if (data) {
        data = JSON.parse(data);
        if (Array.isArray(data.answers)) {
          this.user_answers = {};
        } else {
          this.user_answers = data.answers;
        }
        this.finished = !!data.finished;
        this.score = data.score;
        this.currentQuestionIndex = data.currentQuestionIndex || 1;
        this.checkIfFinished();
        this.scrollToCurrentQuestion();
      }
    },
  },
  mounted() {
    this.getAnswersFromStorage();
  },
  computed: {
    currentQuestion: function () {
      return this.questions[this.currentQuestionIndex] || this.questions[0];
    },
  },
};
</script>
